<template>
  <div class="order-status">
    <div class="title-lists">
      <el-button
        size="mini"
        icon="el-icon-delete"
        :disabled="selectIds.length < 1"
        @click="deleteStatus"
        >{{ $lange == "en" ? "Delete" : "删除分类" }}</el-button
      >
      <el-button
        size="mini"
        icon="el-icon-delete"
        :disabled="selectIds.length == 1 ? false : true"
        @click="editStatus"
        >{{ $lange == "en" ? "Edit" : "編輯分类" }}</el-button
      >
      <!--            这里的添加分类一开始说需要，后面提出可以删除 暂时隐藏-->
      <!--            <el-button size="mini" icon="el-icon-plus" >添加分类</el-button>-->
    </div>
    <div class="content-lists">
      <div class="title">
        <span>{{ $lange == "en" ? "Category of Failure " : "故障分类" }}</span>
        <el-button @click="addStatus2" size="mini" type="primary">{{ $lange == "en" ? "Add" : "添加分类" }}</el-button>
      </div>
      <div class="context">
        <div class="context-list" v-for="(item, index) in statusArr">
          <el-checkbox
            v-model="item.isChecked"
            @change="checkChange($event, item.id, false, item)"
            >{{ $lange == "en" ?  item.engName : item.name }}</el-checkbox
          >
        </div>

        <!-- <div class="context-list">
          <el-input
            :placeholder="
              $lange == 'en' ? 'Please enter content' : '请输入内容'
            "
            size="mini"
            v-model="defaultName"
          >
            <template slot="append">
              <div class="solt-append" @click="addStatus">
                <i class="el-icon-plus"></i>
              </div>
            </template>
          </el-input>
        </div> -->
      </div>
    </div>
    <div class="content-lists">
      <div class="title">
        <span>{{ this.$lange == "en" ? "Source of Failure" : "问题来源" }}</span>
         <el-button @click="addStatus2(true)" size="mini" type="primary">{{ $lange == "en" ? "Add" : "添加问题来源" }}</el-button>
      </div>
      <div class="context">
        <div class="context-list" v-for="(item, index) in problemArr">
          <el-checkbox
            v-model="item.isChecked"
            @change="checkChange($event, item.id, true, item)"
            >{{ $lange == "en" ?  item.engName : item.name }}</el-checkbox
          >
        </div>
        <!-- <div class="context-list">
          <el-input
            :placeholder="
              $lange == 'en' ? 'Please enter content' : '请输入内容'
            "
            size="mini"
            v-model="problemName"
          >
            <template slot="append">
              <div class="solt-append" @click="addStatus(true)">
                <i class="el-icon-plus"></i>
              </div>
            </template>
          </el-input>
        </div> -->
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="$lange == 'en' ?  'Edit' : '编辑'"
      :visible.sync="addDialog"
      width="50%"
      append-to-body
    >
      <cc-form
        :config="formConfig"
        v-model="editData"
        ref="editForm"
        :rules="rules"
        labelWidth="120px"
      >
      </cc-form>
      <el-button type="primary" size="mini" @click="doSubmit">{{$lange == 'en' ?  'Save' : '保存'}}</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OrderStatus",
  data() {
    return {
      problemArr: [],
      statusArr: [],
      problemName: "",
      defaultName: "",
      selectIds: [],
      editData: {},
      addDialog: false,
      rules: {
        name: [{ required: true, message: "中文名称不可为空", trigger: "blur" }],
        engName: [{ required: true, message: "英文名称不可为空", trigger: "blur" }],
      },
      formConfig: {
        props: [
          {
            type: "input",
            name: "name",
            label: this.$lange == 'en' ?  'Name' : '中文名称',
            disabled: false,
          },
            {
            type: "input",
            name: "engName",
            label: this.$lange == 'en' ?  'Name(EN)' : '英文名称',
            disabled: false,
          },
        ],
      },
    };
  },
  methods: {
    getAttribute() {
      this.ccRequest
        .do("admin/fsb/work/order/attribute/query", { pageSize: 999 }, "GET")
        .then((res) => {
          this.selectIds = [];
          this.problemArr = [];
          this.statusArr = [];
          for (let i in res.rows) {
            res.rows[i].isChecked = false;
            if (res.rows[i].code == 1) {
              this.problemArr.push(res.rows[i]);
            } else {
              this.statusArr.push(res.rows[i]);
            }
          }
        });
    },
    getData() {
      this.getAttribute();
    },
    addStatus(isProblem = false) {
      let data = {};
      if (isProblem === true) {
        data.code = 1;
        data.name = this.problemName;
      } else {
        data.code = 0;
        data.name = this.defaultName;
      }
      if (data.name.length < 1) {
        this.$message({
          type: "warning",
          message: "请输入内容",
        });
        return false;
      }
      this.ccRequest
        .do("admin/fsb/work/order/attribute/save", data, "POSTJSON")
        .then((res) => {
          data.isChecked = false;
          let newData = {
            id: res.id,
            ...data,
          };

          if (isProblem === true) {
            this.problemArr.push(newData);
          } else {
            this.statusArr.push(newData);
          }
          setTimeout(() => {
            this.defaultName = "";
            this.problemName = "";
          });
          this.$message({
            type: "success",
            message: "添加成功",
          });
        });
    },
    addStatus2(isProblem = false) {
      this.editData={}
      if (isProblem === true) {
        this.editData.code = 1;
      } else {
        this.editData.code = 0;
      }
      this.addDialog = true;

    },
    checkChange(res, id, isProblem = false, item) {
      console.log(res);

      if (res) {
        this.selectIds.push(id);
      } else {
        for (let i in this.selectIds) {
          if (id === this.selectIds[i]) {
            this.selectIds.splice(i, 1);
          }
        }
      }
    },
    deleteStatus() {

      let text='删除问题/分类会影响服务请求相关数据的显示，是否确定继续删除?';
      
      this.$confirm(text, this.$lange == "en" ?  'Tips' : '提示' , {
        // confirmButtonText: "确定",
        // cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          ids: this.selectIds.join(","),
        };
        this.ccRequest
          .do("admin/fsb/work/order/attribute/batchDelete", data, "GET")
          .then((res) => {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getAttribute();
            this.statusArr = [];
            this.problemArr = [];
          });
      });
    },
    editStatus(e) {
      console.log(this.selectIds);
      let data = [...this.problemArr, ...this.statusArr];
      for (let index = 0; index < data.length; index++) {
        if (data[index].id == this.selectIds[0]) {
          this.editData = { ...data[index] };
          break;
        }
      }
      this.addDialog = true;
    },
    doSubmit() {
      this.$refs["editForm"]
        .validate()
        .then(() => {
          let editData = { ...this.editData };
          this.ccRequest
            .do("admin/fsb/work/order/attribute/save", editData, "POSTJSON")
            .then((res) => {
              this.addDialog = false;
              this.editData = {};
              this.$message.success("修改成功");

              setTimeout(() => {
                this.getData();
              }, 500);
            })
            .catch((er) => {
              this.$message.error(er.response.data.message);
            });
        })
        .catch(() => {});
    },
  },

  mounted() {
    this.getData();
  },
};
</script>
<style>
.order-status .el-input-group__append {
  padding: 0;
}
</style>
<style scoped lang="scss">
.order-status {
  .title-lists {
    padding: 20px;
    background: #ffffff;
  }
  .content-lists {
    margin-top: 20px;
    background: #ffffff;
    .title {
      font-size: 18px;
      padding: 20px;
      border-bottom: 1px solid #e4e4e4;
      span {
        margin-right: 20px;
      }
    }
    .context {
      font-size: 16px;
      padding: 20px;
      display: flex;
      .context-list {
        margin-right: 20px;
      }
    }
  }
  .solt-append {
    width: 100%;
    height: 100%;
    cursor: pointer;
    padding: 0 20px;
  }
}
</style>
